import Api from '@/services/Api'

const URL = 'cat/tiendas/';

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    }
}